import BookGroup from "components/BookGroup";
import {
  BookGroupSizeType,
  BookPromptContextType,
} from "components/BookGroup/types";
import BookPromptHeader from "components/BookGroup/headers/BookPromptHeader";
import BookGroupPromptItem from "components/BookGroup/items/BookGroupPromptItem";
import { BookSerializersBookByline, PromptSerializersPrompt } from "types/serializers";

export default function BookPromptGroup({
  prompt,
  activeBook,
  size,
  context = {},
  className
}: {
  activeBook?: BookSerializersBookByline;
  prompt: PromptSerializersPrompt;
  size: BookGroupSizeType;
  context?: BookPromptContextType;
  className?: string;
}) {
  const books = prompt.promptBooks.map((pb) => pb.book);
  return (
    <BookGroup
      size={size}
      books={
        size === "lg"
          ? books.slice(0, context.maxBooks || 12)
          : books.slice(0, context.maxBooksSm || 7)
      }
      className={className}
      HeaderComponent={BookPromptHeader}
      ItemComponent={BookGroupPromptItem}
      context={{
        ...context,
        prompt,
        activeBook,
      }}
    />
  );
}
